/* eslint-disable @typescript-eslint/no-explicit-any */
import { mergeRightAllWithArrays } from "@zoovu/runner-browser-api";
import {
  ConfigurationValues,
  standardTextsConfigurationValues,
  topProductConfigurationValues,
  ValuesConfigurationProvider
} from "@zoovu/runner-web-design-base";

export default class CustomizedStandardTextsValuesConfigurationProvider extends ValuesConfigurationProvider {
  constructor(
    private readonly standardTextsConfigurationDiffValues: { standardTexts: any },
    private readonly topProductConfigurationDiffValues: { topProductSettings: any }
  ) {
    super();
  }

  public provide(configurationValues: ConfigurationValues): any {
    switch (configurationValues) {
      case ConfigurationValues.TopProduct:
        return mergeRightAllWithArrays(
          topProductConfigurationValues,
          this.topProductConfigurationDiffValues
        ).topProductSettings;
      case ConfigurationValues.StandardTexts:
        return mergeRightAllWithArrays(
          standardTextsConfigurationValues,
          this.standardTextsConfigurationDiffValues
        ).standardTexts;
      default:
        return {};
    }
  }
}
